/* BG-225 card peek: lets the CSS in main.css (BG-225 blocks) show a cut-off game title in full on hover/focus, and closes
   hover/focus reveals with Escape (WCAG 1.4.13). Delegated, so cards added by load-more, filters and the wishlist grid work.
   BG-256 award tips (.aw, snippets/award-badge.liquid): hover/focus show the tip in CSS; this file sizes it to the room inside
   the card and viewport (fit), pins it on tap/click, closes it on Escape, outside click or when its award scrolls out of
   view, and keeps aria-expanded true exactly while the tip is shown (sync). Every close goes through close(). */
(function () {
  'use strict';
  var SEL = '.card--product';
  var HOVER_OR_FOCUS = SEL + ':hover, ' + SEL + ':focus-within';
  function card(el) {
    return el && el.closest ? el.closest(SEL) : null;
  }
  function kept(el) {
    // chips, stars and the proof line hide while the title is expanded, so they do not count as room
    return !(el.classList.contains('pcard-chips') || el.classList.contains('fc-addon') || (el.classList.contains('pcard-proof') && !el.querySelector('.aw')) ||
      (el.tagName === 'DIV' && el.querySelector(':scope > .rating')) || el.getBoundingClientRect().height === 0);
  }
  function measure(c) {
    c.removeAttribute('data-peek-title');
    var a = c.querySelector('.pcard-title a');
    var p = a && a.parentElement;
    if (!p || a.scrollHeight <= a.clientHeight + 1) return;
    var next = p.nextElementSibling;
    while (next && !kept(next)) next = next.nextElementSibling;
    if (!next) return;
    var room = next.getBoundingClientRect().top - p.getBoundingClientRect().bottom;
    if (room >= parseFloat(getComputedStyle(a).lineHeight)) c.setAttribute('data-peek-title', '');
  }
  function arrive(e) {
    if (e.pointerType === 'touch') return;
    var c = card(e.target);
    if (c && !(e.relatedTarget && c.contains(e.relatedTarget))) measure(c);
  }
  function leave(e) {
    var c = card(e.target);
    if (!c || (e.relatedTarget && c.contains(e.relatedTarget))) return;
    requestAnimationFrame(function () {
      if (!c.matches(':hover, :focus-within')) {
        c.removeAttribute('data-peek-title');
        c.removeAttribute('data-peek-off');
      }
    });
  }
  document.addEventListener('pointerover', arrive);
  document.addEventListener('focusin', arrive);
  document.addEventListener('pointerout', leave);
  document.addEventListener('focusout', leave);
  var openAward = null;
  var hoverMq = window.matchMedia('(hover: hover)');
  function awOf(el) {
    return el && el.closest ? el.closest('.aw') : null;
  }
  function anchorOf(aw) {
    return aw.closest('.pcard-proof, .sp-award');
  }
  function usableTop() {
    // bottom edge of the sticky header while it shows; a hidden header sits above the window, so it drops out
    var h = document.querySelector('store-header[data-is-sticky="true"]');
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  }
  function fit(aw) {
    var box = aw.closest('.card--product, .sp');
    var anchor = anchorOf(aw);
    var list = aw.querySelector('.aw__list');
    if (!box || !anchor || !list) return;
    var b = box.getBoundingClientRect();
    var a = anchor.getBoundingClientRect();
    var top = Math.max(b.top, usableTop());
    var bottom = Math.min(b.bottom, window.innerHeight);
    var up = a.top - top - 14;
    var down = bottom - a.bottom - 14;
    if (down > up) aw.setAttribute('data-below', ''); else aw.removeAttribute('data-below');
    aw.style.setProperty('--aw-room', Math.min(320, Math.max(0, Math.floor(Math.max(up, down)))) + 'px');
    // Safari does not focus scroll boxes, so only a list that scrolls gets a Tab stop
    if (list.scrollHeight > list.clientHeight + 1) list.setAttribute('tabindex', '0');
    else if (document.activeElement !== list) list.removeAttribute('tabindex');
  }
  function sync(aw) {
    var btn = aw.querySelector('.aw__btn');
    var on = !aw.hasAttribute('data-award-off') && (aw.hasAttribute('data-open') ||
      !!aw.querySelector(':focus-visible') || (hoverMq.matches && aw.matches(':hover')));
    if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function later(aw) {
    requestAnimationFrame(function () { sync(aw); });
  }
  function arm(aw) {
    aw.removeAttribute('data-award-off');
    fit(aw);
  }
  function close(aw, off) {
    aw.removeAttribute('data-open');
    if (off) aw.setAttribute('data-award-off', '');
    if (openAward === aw) openAward = null;
    later(aw);
  }
  document.addEventListener('click', function (e) {
    var aw = awOf(e.target);
    if (openAward && openAward !== aw) close(openAward);
    var btn = e.target.closest ? e.target.closest('.aw__btn') : null;
    if (!btn) return;
    if (aw.hasAttribute('data-open')) {
      close(aw);
    } else {
      arm(aw);
      aw.setAttribute('data-open', '');
      openAward = aw;
      later(aw);
    }
  });
  document.addEventListener('focusin', function (e) {
    var aw = awOf(e.target);
    if (!aw) return;
    if (e.target.classList.contains('aw__btn')) arm(aw);
    later(aw);
  });
  document.addEventListener('pointerover', function (e) {
    var aw = awOf(e.target);
    if (!aw) return;
    if (!(e.relatedTarget && aw.contains(e.relatedTarget))) arm(aw);
    later(aw);
  });
  ['focusout', 'pointerout'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var aw = awOf(e.target);
      if (aw) later(aw);
    });
  });
  var queued = false;
  function refit() {
    queued = false;
    var top = usableTop();
    document.querySelectorAll('.aw[data-open], .aw:hover, .aw:focus-within').forEach(function (aw) {
      var r = anchorOf(aw).getBoundingClientRect();
      if (r.top < top - 1 || r.bottom > window.innerHeight + 1) close(aw, true);
      else fit(aw);
    });
  }
  function queueRefit() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refit);
  }
  window.addEventListener('scroll', queueRefit, { passive: true });
  window.addEventListener('resize', queueRefit);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(HOVER_OR_FOCUS).forEach(function (c) { c.setAttribute('data-peek-off', ''); });
    document.querySelectorAll('.aw:hover, .aw:focus-within, .aw[data-open]').forEach(function (aw) {
      // focus moves first: that focusin re-arms the award, and close(aw, true) then switches it off
      if (aw.querySelector('.aw__tip').contains(document.activeElement)) aw.querySelector('.aw__btn').focus();
      close(aw, true);
    });
  });
})();
